import Ajax from 'global/od/Ajax';

const getData = function (url, data) {
	return Ajax({
		url,
		method: 'GET',
		dataType: 'json',
		data,
	});
};

const getDropdownData = {
	series(data) {
		return getData('/ink-toner-finder/ajax/device/model-series-by-brand', {
			manufacturerId: data.brand.selectedOption.value,
		});
	},
	model(data) {
		return getData('/ink-toner-finder/ajax/devices', {
			manufacturerId: data.brand.selectedOption.value,
			modelSeriesId: data.series.selectedOption.value,
		});
	},
};

export default getDropdownData;
